import { render, staticRenderFns } from "./DeltaPercentage.vue?vue&type=template&id=5d4cf790&"
import script from "./DeltaPercentage.vue?vue&type=script&lang=js&"
export * from "./DeltaPercentage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports